import config from 'config'
import createAlgoliaHelper from 'utils/createAlgoliaHelper'
import * as t from './types'
import React from 'react'

export default function useServiceReviews() {
  const [reviews, setReviews] = React.useState<t.Fetch | null>(null)
  const locale = config.i18n.locale

  React.useEffect(() => {
    const fetchReviews = async () => {
      const helper = await createAlgoliaHelper(
        config.index.serviceReviews || '',
        {
          facets: ['locale', 'rating'],
          distinct: 0,
          attributesToRetrieve: [
            'objectID',
            'rating',
            'reviewer',
            'originalReview',
            'verified',
            'locale',
            'createdAt'
          ]
        }
      )
      const getFormatedLocale = (locale: string) =>
        locale === 'en_GB' ? 'en' : locale.replace('_', '-')
      helper.addFacetRefinement('locale', locale.replace('-', '_'))
      helper.addFacetRefinement('rating', '5')

      const result = await helper.searchOnce({ hitsPerPage: 100 })

      let data: t.Fetch | null = result.content.hits
      if (!data) return

      data = result.content.hits.map((hit) => ({
        ...hit,
        locale: getFormatedLocale(hit.locale),
        originalReview: {
          ...hit.originalReview,
          locale: getFormatedLocale(hit.originalReview.locale)
        }
      }))

      setReviews(data)
    }

    fetchReviews()
  }, [])

  return reviews
}
